/**
 * Service-worker registration without an inline script (CSP: `script-src 'self'`). vite-plugin-pwa runs with
 * `injectRegister: null`; this module registers from the bundle in production builds only. The worker caches
 * the shell and fonts; `/v1` is network-first for lottery reads and network-only for anything that carries an
 * outcome, payment or claim (vite.config.ts).
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  void import('virtual:pwa-register')
    .then(({ registerSW }) => {
      registerSW({
        immediate: true,
        onRegisterError(error: unknown) {
          console.warn('[windrop] service worker registration failed', error);
        },
      });
    })
    .catch(() => {
      /* offline shell is an enhancement */
    });
}
